import { render, staticRenderFns } from "./NumberTemplate.vue?vue&type=template&id=37755114&"
import script from "./NumberTemplate.vue?vue&type=script&lang=ts&"
export * from "./NumberTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports